import { render, staticRenderFns } from "./tabletop.vue?vue&type=template&id=501ac438&scoped=true"
import script from "./tabletop.vue?vue&type=script&lang=js"
export * from "./tabletop.vue?vue&type=script&lang=js"
import style0 from "./tabletop.vue?vue&type=style&index=0&id=501ac438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501ac438",
  null
  
)

export default component.exports